// extracted by mini-css-extract-plugin
export default {"root":"_3w9r0","label":"_3SPXF"};